




























































































































































import SeismicForm from '@/models/SeismicForm'
import ValveAndLocation from '@/components/SeismicInsepctionForm/ValveAndLocation.vue'
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'

export default Vue.extend({
  name: 'Conclusion',
  components: {
    ValveAndLocation
  },
  props: {
    form: { type: [SeismicForm, Object] }
  },
  computed: {
    ...mapGetters(['getIsPrintablePDFMode'])
  },
  data () {
    return {
      specificPoints: [] as Array<string>
      // localForm: JSON.parse(JSON.stringify(this.form))
    }
  },
  // watch: {
  //   form () {
  //     this.localForm = JSON.parse(JSON.stringify(this.form))
  //   }
  // },
  created () {
    this.activatePrintablePDFMode()
  },
  beforeDestroy () {
    this.$emit('saveForm')
    this.deactivatePrintablePDFMode()
  },
  methods: {
    ...mapActions(['activatePrintablePDFMode', 'deactivatePrintablePDFMode'])
  }
})

